import React, { useEffect, useState } from "react";
import classes from "./Product.module.css"
import cart from "../../img/cart.png"
import packet from "../../img/packet.png"
import { Link } from "react-router-dom";

const Product = (props) => {

    const [bgStyleP, setbgStyleP] = useState("rgba(42, 74, 201, 0.07)")
    const [zindexStyleP, setXindexStyleP] = useState("1")
    const [dispStyleP, setDispStyleP] = useState("none")
    const [blurImgStyleP, setBlurImgStyleP] = useState("none")
    const [textStyle1P, setTextStyle1P] = useState("black")
    const [textStyle2P, setTextStyle2P] = useState("#8C8C8C")
    const [visibilityOp, setVisibilityOp] = useState(props.visible || 1)
    const [visibilityDi, setVisibilityDi] = useState("flex")
    const [visibilityTr, setVisibilityTr] = useState("0")
    const [isFirstRender, setIsFirstRender] = useState(true)

    // Ф-ия при наведении на продукт
    const bgStylePFuncOver = () => {
        setbgStyleP("rgba(72, 99, 209, 1)")
        setXindexStyleP("0.30")
        setDispStyleP("block")
        setTextStyle1P("white")
        setTextStyle2P("white")
        setBlurImgStyleP("12px")
    }
    const bgStylePFuncOut = () => {
        setbgStyleP("rgba(42, 74, 201, 0.07)")
        setXindexStyleP("1")
        setDispStyleP("none")
        setTextStyle1P("black")
        setTextStyle2P("#8C8C8C")
        setBlurImgStyleP("0")
    }

    useEffect(() => {
        if (!isFirstRender) {
            if (props.visible === "0") {
                // setVisibilityOp("0")
                // setVisibilityTr("translateX(-350px)")
                setTimeout(()=> {
                    setVisibilityDi("none")
                },200)
            } else {
                // setVisibilityTr("translateX(-350px)")
                setTimeout(()=> {
                    setVisibilityDi("flex")
                    setVisibilityTr("translateX(0)")
                    setVisibilityOp("1")
                },200)
            }
        } else {
            setIsFirstRender(false)
        }
    }, [props.visible])
    
    return (
        // Искро-взрывобезопасный
        <Link 
            onClick={()=>{window.scrollTo(0,0)}} 
            style={{opacity: visibilityOp, display: visibilityDi, transform: visibilityTr}} 
            className={classes.aProduct} 
            to={"/ProductCard?" + (props.text.slice(4) === "4753-10" ? (props.exText === "" ? props.text.slice(4) + "/1" : (props.exText === "Искро-взрывобезопасный" ? props.text.slice(4) + "/2" : props.text.slice(4) + "/3")) : props.text.slice(4))}>
            <div onMouseOver={bgStylePFuncOver} onMouseOut={bgStylePFuncOut} style={{backgroundColor: bgStyleP}} className={classes.Product}>
            <div style={{backdropFilter: blurImgStyleP}} className={classes.imageProduct}>
                <img style={{opacity: zindexStyleP}} src={props.imgSrc} alt={props.imgAlt} />
            </div>
            <div className={classes.contentText}>
                <h1 style={{color: textStyle1P}}>{props.text}</h1>
                <h2 style={{color: textStyle2P}}>{props.exText}</h2>
            </div>
            <div style={{display: dispStyleP}} className={classes.buttonsP}>
                <button title="Открыть карточку товара" className={classes.buttonMainP} href="/Profile">Открыть</button>
                <div className={classes.exButtonsP}>
                    <Link to="/Profile"><button title="Добавить в корзину"><img src={cart} alt="К" /></button></Link>
                    <Link to={"/ProductCard?" + (props.text.slice(4) === "4753-10" ? (props.exText === "" ? props.text.slice(4) + "/1" : (props.exText === "Искро-взрывобезопасный" ? props.text.slice(4) + "/2" : props.text.slice(4) + "/3")) : props.text.slice(4))}><button title="Купить сразу"><img src={packet} alt="П" /></button></Link>
                </div>
            </div>
        </div></Link>
    )
}

export default Product